module.exports = __webpack_public_path__ + "387cd9737eb15d557b8f4f1495ad6729.png";